// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hO-z","hovered":"iO-z","hoverImage":"jO-z","mainImage":"kO-z","imageNoBackground":"lO-z","fullSizeImage":"mO-z"};